<template>
  <div :class="form_class">
    
    <div v-if="all_check_title" class="allCheck">
      <span class="rdChk">
        <input type="checkbox" id="termsAllChk" @click="checkAll(allChecked)" v-model="allChecked"/>
        <label for="termsAllChk"><span>{{all_check_title}}</span></label>
      </span>
    </div>

    <ul class="termsList">
      <li v-for="(term, k) in terms" :key="k" style="padding: 12px 10px 12px 10px;">
        <div style="">
          <span class="rdChk">
            <input type="checkbox" :id="`term-${term.key}`" v-model="term.checked"/>
            <label :for="`term-${term.key}`">
              <span>{{term.label}} {{ ([ConstTerms.SERVICE_AGREEMENT, ConstTerms.INSURANCE].includes(term.key)) ? '동의' : '' }} {{ (term.required) ? '(필수)' : '(선택)' }}</span>
            </label>
          </span>
          <a v-if="term.showinfo" @click="showTerms(term, k)" class="btnInfo"></a>
        </div>
        <div v-if="term.key == ConstTerms.AD_RECEIVE_AGREE" style="margin-top:10px;">
          <span class="rdChk" style="padding-left:0px; display: block; width: 100%;">
            <span v-for="(adItem) in adTerms" :key="adItem.key" style="padding-left:15px;">
              <input type="checkbox" :id="`ad-receive-${adItem.key}`" v-model="adItem.checked" @change="checkAdItem(k)"/>
              <label :for="`ad-receive-${adItem.key}`"><span style="margin-left:5px;">{{adItem.label}}</span></label>
            </span>
          </span>
        </div>
      </li>
    </ul>

    <popup-terms 
      v-if="activate" 
      :title="termsTitle" 
      :type="termsType" 
      @close="activate=false;" 
      @agreeTerms="agreeTerms">
    </popup-terms>
  </div>
</template>


<script>
import ConstTerms from '../../helpers/ConstTerms';
import PopupTerms from '@/components/Popup/PopupTerms.vue';

export default {
  name: "TermServiceView",

  components: {
    PopupTerms,
  },


  computed: {
    allChecked: {
      get() {
        for (let i in this.terms) {
          if (!this.terms[i].checked) return false;
        }
        return true;
      },
      set() {},
    }
  },

  data() {
    return {
      ConstTerms,

      activate: false,
      termIndex: 0,
      termsTitle: '',
      termsType: null,
    }
  },

  methods: {
    agreeTerms() {
      this.terms[this.termIndex].checked = true;
      this.activate = false;
    },

    checkAll(checked) {
      for (let i in this.terms) {
        this.terms[i].checked = !checked;
      }

      if(this.adTerms) for (let i in this.adTerms) {
        this.adTerms[i].checked = !checked;
      }
    },

    showTerms(term, index) {
      this.termsTitle = term.label;
      this.termsType = term.key;
      this.termIndex = index;
      this.activate = true;
    },

    checkAdItem(key){
      for(let k in this.adTerms){
        if (this.adTerms[k].checked) return;
      }
      this.terms[key].checked = false;
    },
  },

  props: {
    all_check_title: {type: String, default: '전체 동의'},
    form_class: {type: String, default: 'allChkWrap'},
    terms: {type: [Array, Object]},
    adTerms: {type: [Array, Object]},
  },
};
</script>
